import {Fragment} from "preact";
import {serviceTypeIconEnum} from "../../../../utils";
import ChildCategory from "./ChildCategory";

import s from "./groupCategory.module.css";
import {useAppContext} from "../../../../contexts";

const GroupCategory = props => {
    // Destructured props
    const {
        parentCategory,
        index,
        handleChange,
        handleCollapse,
        collapseController,
        selectedCategories,
        additionalCategories
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();


    // Validates whether it is a hidden additional category or not
    let groupClassName =
        (parentCategory["additionalVisibility"] &&
        !additionalCategories.includes(parentCategory.id)) ?
            "hidden" :
            "";

    // Validates whether the group is collapsed or not
    const isCollapsed = collapseController.find(item => item.id === parentCategory.id)?.isCollapsed;

    return (
        <Fragment>
            <div key={parentCategory.id} className={groupClassName}>
                <button
                    type="button"
                    className={`${s.rootGroup} ${(isCollapsed ? "border-b" : "")} dark:bg-black`}
                    onClick={() => handleCollapse({
                        id: parentCategory.id,
                        target: "CLICK"
                    })}
                >
                    <div className="flex items-center justify-between w-full h-full relative dark:text-contrast-yellow">
                        <div className={`${s.nameGroup} ${highContrast ? "after:bg-contrast-yellow" : "after:bg-sabin-red-default"}`}>
                            {!!serviceTypeIconEnum[parentCategory.icon] && (
                                <img
                                    src={serviceTypeIconEnum[parentCategory.icon]}
                                    alt={"Root category icon"}
                                    className={`${highContrast ? "highImage" : ""}`}
                                />
                            )}
                            <p className={`${s.categoryTitle} dark:text-contrast-yellow`}>
                                {parentCategory.name}
                            </p>
                        </div>
                        <p className={`${s.collapsedIcon} ${isCollapsed ? "text-[22px]" : "text-[32px] -mt-0.5"}`}>
                            {(isCollapsed ? "+" : "-")}
                        </p>
                    </div>
                </button>
                <div
                    className={`root-category-body ${(isCollapsed ? "hidden" : "")}`}
                    data-testid="category-form-root-category-body"
                >
                    <div className="px-5 py-4 border border-t-0 border-gray-200 rounded-b dark:border-gray-700 bg-white dark:bg-black flex flex-col justify-start gap-y-2 dark:text-contrast-yellow">
                        {/* The actual categories iterator */}
                        {!!parentCategory.childs && parentCategory.childs.map(childCategory => {
                            return (
                                <ChildCategory
                                    key={childCategory.id}
                                    index={index}
                                    selectedCategories={selectedCategories}
                                    parentCategory={parentCategory}
                                    childCategory={childCategory}
                                    handleChange={handleChange}
                                    additionalCategories={additionalCategories}
                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default GroupCategory;
